(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("campaignListItem", {
            templateUrl:
                "app/admin/campaign/campaign-list-item/campaign-list-item.html",
            controller: CampaignListItemController,
            bindings: {
                item: "=",
                isHubContext: "=",
                onFinish: "&",
                onDeleteItem: "&",
                onViewItem: "&",
                onDuplicateItem: "&",
                onActivateItem: "&",
                onInactivateItem: "&",
                onDistributeItem: "&"
            },
        });

    /** @ngInject */
    function CampaignListItemController($scope, $translate, $uibModal, TargetAudienceService, $window, moment) {
        var $ctrl = this;

        $ctrl.isExpanded = false;
        $ctrl.deadlineMap = {
            NORMAL: "NORMAL",
            MEDIAN: "MEDIAN",
            URGENT: "URGENT",
            INDETERMINATE: 'INDETERMINATE'
        };

        $ctrl.currentPage = 1;
        $ctrl.numPerPage = 10;
        $ctrl.maxSize = 5;

        $ctrl.currentActions = [];
        const DATE_FORMAT = $translate.instant('momentDateFormat');

        $ctrl.allActions = [
            {
                name: 'view',
                icon: "fa fa-eye",
                label: 'entity.action.view',
                method: function () { $ctrl.onViewItem(); }
            },
            {
                name: 'duplicate',
                icon: "fa fa-copy",
                label: 'entity.action.duplicate',
                method: function () { $ctrl.onDuplicateItem(); }
            },
            {
                name: 'delete',
                icon: "fa fa-trash",
                label: 'entity.action.delete',
                method: function () { $ctrl.onDeleteItem(); }
            },
            {
                name: 'distribute',
                icon: "icon-ksc-showcasepublished",
                label: 'campaign.actions.distribute',
                method: function () { $ctrl.onDistributeItem(); }
            },
            {
                name: 'activate',
                icon: "fa fa-check",
                label: 'campaign.action.activate',
                method: function () { $ctrl.onActivateItem(); }
            },
            {
                name: 'inactivate',
                icon: "fa fa-close",
                label: 'campaign.action.inactivate',
                method: function () { $ctrl.onInactivateItem(); }
            },
        ];

        $ctrl.statusDisplayMap = {
            SCHEDULED: {
                class: 'accepted',
                label: 'campaign.list.status.scheduled',
                tooltip: 'campaign.list.status.tooltips.scheduled'
            },
            EXPIRED: {
                class: 'cancelled',
                label: 'campaign.list.status.expired',
                tooltip: 'campaign.list.status.tooltips.expired'
            },
            CANCELLED: {
                class: 'waiting_confirmation',
                label: 'campaign.list.status.cancelled',
                tooltip: 'campaign.list.status.tooltips.cancelled'
            },
            PENDING: {
                class: 'pending',
                label: $ctrl.isHubContext
                    ? 'campaign.list.status.active'
                    : 'campaign.list.status.pending',
                tooltip: $ctrl.isHubContext
                    ? 'campaign.list.status.tooltips.active'
                    : 'campaign.list.status.tooltips.pending'
            },
            DOING: {
                class: 'waiting_payment',
                label: 'campaign.list.status.doing',
                tooltip: 'campaign.list.status.tooltips.doing'
            },
            DONE: {
                class: 'paid',
                label: 'campaign.list.status.done',
                tooltip: 'campaign.list.status.tooltips.done'
            },
            EMPTY: {
                class: 'empty',
                label: 'campaign.list.status.empty',
                tooltip: 'campaign.list.status.tooltips.empty'
            },
            INACTIVE: {
                class: 'cancelled',
                label: 'campaign.list.status.inactive',
                tooltip: 'campaign.list.status.tooltips.inactive'
            },
            NEW: {
                class: 'accepted',
                label: 'campaign.list.status.new',
                tooltip: 'campaign.list.status.tooltips.new'
            }
        };

        function calculatePercentage(done, total) {
            return total > 0 ? ((done / total) * 100).toFixed(0) : "0";
        }

        $ctrl.$onInit = function () {
            if($ctrl.item.expirationDate) {
                $ctrl.formatedExpirationDate =  moment($ctrl.item.expirationDate).format(DATE_FORMAT);
            }
            if($ctrl.item.activationDate) {
                $ctrl.formatedActivationDate =  moment($ctrl.item.activationDate).format(DATE_FORMAT);
            }
            $ctrl.mobileTooltipMap = {};
            $ctrl.percentage = calculatePercentage(
                $ctrl.item.totalActivitiesFinished,
                $ctrl.item.totalActivities
            );
            $ctrl.content =
                $ctrl.item.totalActivitiesFinished +
                "/" +
                $ctrl.item.totalActivities;

            updateIsMobile();
            getActions();
            updateStatusTag();
        };

        $ctrl.$getDateDeadline = function (expirationDate) {
            if (!expirationDate) {
                return $ctrl.deadlineMap.INDETERMINATE;
            }


            var today = moment().startOf('day');
            var expiration = moment(expirationDate).startOf('day');
            var diffInDays = expiration.diff(today, 'days');

            if (diffInDays >= 0 && diffInDays <= 1) {
                return $ctrl.deadlineMap.URGENT;
            } else if (diffInDays >= 2 && diffInDays <= 4) {
                return $ctrl.deadlineMap.MEDIAN;
            } else {
                return $ctrl.deadlineMap.NORMAL;
            }
        };

        $ctrl.toggleMobileTooltip = function (id, $event) {
            Object.keys($ctrl.mobileTooltipMap).forEach(function (key) {
                $ctrl.mobileTooltipMap[key] = false;
            });

            $ctrl.mobileTooltipMap[id] = true;
            $event.stopPropagation();
        };

        $ctrl.isTooltipOpen = function (id) {
            return $ctrl.mobileTooltipMap && $ctrl.mobileTooltipMap[id];
        };

        $ctrl.openViewTargetAudienceMenu = function () {
            return $uibModal.open({
                templateUrl: 'app/admin/campaign/target-audience/create-target-audience/create-target-audience.html',
                controller: 'CreateTargetAudienceController',
                controllerAs: 'vm',
                windowClass: 'alt-side-modal full-screen-modal',
                backdrop: 'static',
                resolve: {

                    targetAudienceId: function () {
                        return $ctrl.item.targetAudienceId;
                    },
                    isViewMode: function () {
                        return true;
                    }
                }
            }).result.then(function (createdItem) {
                if (!createdItem) return
                vm.targetAudience = createdItem;
            });
        };

        function getActions() {
            var actionsDefault = ['view', 'duplicate', 'delete'];
            var status = $ctrl.item.status;
            if ($ctrl.isHubContext && status !== 'INACTIVE') {
                actionsDefault.push('distribute');
            }
            if(status !== 'DONE' &&  status !== 'EXPIRED' && status !== 'CANCELLED' && status === 'INACTIVE' && status !== 'EMPTY') {
                actionsDefault.push('activate');
            }

            if(status !== 'DONE' &&  status !== 'EXPIRED' && status !== 'CANCELLED' && status !== 'INACTIVE' && status !== 'EMPTY') {
                actionsDefault.push('inactivate');
            }

            $ctrl.currentActions = $ctrl.allActions.filter(function(action) {
                return actionsDefault.includes(action.name);
            });
        }

        function updateStatusTag() {
            var status = $ctrl.item.status;
            var statusConfig = $ctrl.statusDisplayMap[status];

            if (!statusConfig) {
                $ctrl.statusTag = null;
                return;
            }

            $ctrl.statusTag = {
                class: statusConfig.class,
                label: $translate.instant(statusConfig.label),
                tooltip: $translate.instant(statusConfig.tooltip)
            };
        }

        function updateIsMobile() {
            $ctrl.isMobile = $window.innerWidth <= 768;
        }

        $scope.$watch('$ctrl.item.status', function () {
            getActions();
            updateStatusTag();
        });

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });
    }
})();
